import styled, { keyframes } from "styled-components";
import { teal01 } from "../../../styles/tokens";

// TEXT

// STYLES
const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const Wrapper = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  animation: ${fadeIn} 0.4s ease-out;
`;

export const Path = styled.path`
  fill: none;
  stroke: ${teal01};
  stroke-width: 3px;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
`;

// DATA

// TYPES
export type Props = {
  overlay: { key: string; intensity: number }[];
};

// CONSTANTS

// FUNCTIONS
export const buildPath = (overlay: { intensity: number }[]): string => {
  const values = overlay.map((o) => o.intensity);

  const min = Math.min(...values);
  const max = Math.max(...values);

  const range = max - min || 1;

  const points = overlay.map((o, i) => ({
    x: i,
    y: 1 - (o.intensity - min) / range,
  }));

  const path = points.reduce((d, point, i, all) => {
    if (i === 0) return `M ${point.x} ${point.y}`;

    // First point
    const prev = all[i - 1];

    // Midpoint between prev and current point
    const midX = (prev.x + point.x) / 2;
    const midY = (prev.y + point.y) / 2;

    // Quadratic curve: pulls the curve toward the real data point
    return `${d} Q ${prev.x} ${prev.y} ${midX} ${midY}`;
  }, "");

  const last = points[points.length - 1];

  return `${path} L ${last.x} ${last.y}`;
};

// ASSETS
